import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CustomGroupChannelListSkeleton = () => {
  return /*#__PURE__*/_jsx("section", {
    children: Array(3).fill(0).map((_, index) => /*#__PURE__*/_jsxs("div", {
      className: "flex w-full gap-2 p-4 cursor-pointer",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Skeleton, {
          circle: true,
          baseColor: "var(--gray-80)",
          width: 40,
          height: 40
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-grow min-w-[1px] flex flex-col justify-center",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          baseColor: "var(--gray-80)",
          width: 40,
          height: 16,
          className: "!rounded-lg"
        }), /*#__PURE__*/_jsx(Skeleton, {
          baseColor: "var(--gray-80)",
          width: 232,
          height: 20,
          className: "!rounded-lg"
        })]
      })]
    }, index))
  });
};
export default CustomGroupChannelListSkeleton;